import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

function ProfilePage() {
  const { user, logout } = useAuth()
  const [isEditing, setIsEditing] = useState(false)

  if (!user) {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>Profile</h1>
        </div>
        <div className="page-content">
          <p>Loading profile...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>My Profile</h1>
        <p>Manage your account information</p>
      </div>

      <div className="page-content">
        <div className="profile-card">
          <div className="profile-info">
            <h2>Account Information</h2>
            
            <div className="info-group">
              <label>Email</label>
              <p>{user.email}</p>
            </div>

            <div className="info-group">
              <label>Account Type</label>
              <p>{user.isAdmin ? 'Administrator' : 'Member'}</p>
            </div>

            {user.groups && user.groups.length > 0 && (
              <div className="info-group">
                <label>Groups</label>
                <p>{user.groups.join(', ')}</p>
              </div>
            )}
          </div>

          <div className="profile-actions">
            <button 
              className="btn btn-secondary"
              onClick={() => setIsEditing(!isEditing)}
            >
              {isEditing ? 'Cancel' : 'Edit Profile'}
            </button>
            
            <button 
              className="btn btn-danger"
              onClick={logout}
            >
              Sign Out
            </button>
          </div>
        </div>

        {isEditing && (
          <div className="edit-profile-card">
            <h3>Edit Profile</h3>
            <p>Profile editing functionality will be implemented in a future update.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ProfilePage